import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FaReact, FaNodeJs, FaPython, FaAws } from "react-icons/fa";
import { DiDotnet, DiMsqlServer } from "react-icons/di";
import {
  SiMongodb,
  SiExpress,
  SiFigma,
  SiFlutter,
  SiDjango,
  SiFirebase,
  SiSwift,
  SiBlazor,
} from "react-icons/si";

const TechWeLove = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const techList = [
    {
      name: ".NET",
      icon: <DiDotnet color="#512BD4" />,
      description: "A framework developed by Microsoft.",
    },
    {
      name: "MongoDB",
      icon: <SiMongodb color="#47A248" />,
      description: "A NoSQL database for modern applications.",
    },
    {
      name: "Express",
      icon: <SiExpress color="#000000" />,
      description: "A minimal and flexible Node.js web application framework.",
    },
    {
      name: "MSSQL",
      icon: <DiMsqlServer color="#CC2927" />,
      description: "Microsoft's relational database management system.",
    },
    {
      name: "Figma",
      icon: <SiFigma color="#F24E1E" />,
      description: "A web-based UI/UX design tool.",
    },
    {
      name: "Flutter",
      icon: <SiFlutter color="#61DAFB" />,
      description: "A UI toolkit for building natively compiled applications.",
    },
    {
      name: "React",
      icon: <FaReact color="#61DAFB" />,
      description: "A JavaScript library for building user interfaces.",
    },
    {
      name: "Node.js",
      icon: <FaNodeJs color="#339933" />,
      description: "A JavaScript runtime built on Chrome's V8 engine.",
    },
    {
      name: "Python",
      icon: <FaPython color="#3776AB" />,
      description: "A high-level, interpreted programming language.",
    },
    {
      name: "Django",
      icon: <SiDjango color="#092E20" />,
      description: "A high-level Python web framework.",
    },
    {
      name: "AWS",
      icon: <FaAws color="#FF9900" />,
      description: "Amazon Web Services, a comprehensive cloud platform.",
    },
    {
      name: "Firebase",
      icon: <SiFirebase color="#FFCA28" />,
      description: "A platform for building mobile and web applications.",
    },
    {
      name: "Swift",
      icon: <SiSwift color="#FA7343" />,
      description: "A powerful programming language for iOS and macOS.",
    },
    {
      name: "Blazor",
      icon: <SiBlazor color="#512BD4" />,
      description: "A framework for building interactive web UIs using C#.",
    },
  ];

  return (
    <div
      className="px-4 md:px-10 lg:px-20 py-10 relative"
      style={{
        backgroundImage:
          "url('https://img.freepik.com/free-vector/white-background-with-blue-tech-hexagon_1017-19366.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Semi-transparent overlay */}
      <div className=" absolute inset-0 bg-gray-100 bg-opacity-80"></div>
      <div className="relative z-10">
        <h1 className="font-semibold text-primary text-xl md:text-2xl  lg:text-3xl text-center mb-2">
          Our Technology Stack
        </h1>
        <p className="text-center text-gray-600 text-sm sm:text-base md:text-lg mb-2">
          We leverage a variety of modern technologies to deliver cutting-edge
          solutions. Here are some of the key tools and frameworks we use.
        </p>
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={2000}
          arrows={false}
        >
          {techList.map((tech, index) => (
            <div key={index} className="p-4">
              <div className="bg-white shadow-lg rounded-lg p-6 text-center flex flex-col items-center justify-center h-full min-h-[200px] transform transition-transform duration-300 hover:scale-105 hover:bg-gradient-to-r hover:from-[#e0f7f8] hover:via-white hover:to-[#e0f7f8]">
                <div className="text-4xl mb-2">{tech.icon}</div>
                <h2 className="text-lg font-semibold text-black">
                  {tech.name}
                </h2>
                <p className="text-sm text-gray-700 mt-2">{tech.description}</p>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default TechWeLove;
